<p-dialog
  [header]="copy()?.title ?? ''"
  [visible]="visible()"
  (visibleChange)="!$event && close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!saving()"
  [dismissableMask]="!saving()"
  appendTo="body"
  [style]="{ width: 'min(30rem, calc(100vw - 2rem))' }">
  @if (copy(); as c) {
    <div class="flex flex-col gap-4 pt-1">
      <p class="text-sm text-slate-600 m-0">
        <span class="font-medium text-slate-900">{{ mandate()?.number }}</span> · {{ mandate()?.customerName }}
      </p>
      <p class="text-sm text-slate-600 m-0">{{ c.text }}</p>
      @if (c.reason) {
        <p-floatlabel variant="on">
          <textarea
            pTextarea
            id="mit-status-reason"
            rows="3"
            maxlength="500"
            class="w-full"
            [ngModel]="reason()"
            (ngModelChange)="reason.set($event)"
            [disabled]="saving()"></textarea>
          <label for="mit-status-reason">Motivo{{ action() === 'revoke' ? ' *' : '' }}</label>
        </p-floatlabel>
      }
      @if (error()) {
        <p class="text-sm text-red-600 m-0">{{ error() }}</p>
      }
    </div>
  }
  <ng-template #footer>
    <div class="flex justify-end gap-2">
      <p-button label="Cerrar" severity="secondary" [text]="true" type="button" [disabled]="saving()" (onClick)="close()" />
      <p-button
        [label]="copy()?.confirm ?? ''"
        [severity]="action() === 'reactivate' ? 'primary' : 'danger'"
        type="button"
        [loading]="saving()"
        (onClick)="confirm()" />
    </div>
  </ng-template>
</p-dialog>
